import Stack from 'react-bootstrap/Stack';
import HorizontalSlider from 'react-horizontal-slider'
import 'react-horizontal-slider/build/main.css';

import offers from '../data/homepage_offers'

import backgroundStoreImage from '../images/bg_4.png'; 
import LogoHeader from '../components/logoheader/logoHeader'

import '../css/homepage.css';

import {Container, Row, Col} from 'react-bootstrap';
import {
 Button, Nav, NavItem, NavLink,  Card, CardImg, CardText, CardBody,
 CardTitle, CardSubtitle, ListGroup, ListGroupItem
} from 'reactstrap';

import FlyerPizzaDeal from '../images/flyer_pizza_10_per_off.gif'; 
import Flyer10Discount from '../images/flyer_10_discount.png'; 
import FlyerWingsDeal from '../images/flyer_wings_deal.png'; 
import FlyerHappyHour from '../images/flyer_happy_hour.gif';
import FlyerLunchSpecial from '../images/flyer_lunch_special.gif'; 

export default function Homepage() {

  const centerContainer = {
      // display: 'flex',
      // alignItems: 'center',
      // justifyContent:'center',
      // height: '80vh',
      width: '100% !important',
      // backgroundSize: '100% auto', /* Set width to 100% and maintain aspect ratio */
      backgroundRepeat: 'no-repeat',
      // backgroundPosition: 'center',
      margin: '0',
      padding: '5vh 0',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundImage: `url(${backgroundStoreImage})`,
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',
      backgroundPosition: 'center center',
  };
  
  return (
    <>
      <LogoHeader/>
      <div style={centerContainer}>
        <Container  className="container-fluid">
          <Row>
            {/*<Col xs="12" sm="12" md="12"  lg="12" xl="12" className="homepageCol">
              <a target="_blank" href="https://order.toasttab.com/online/oc-pizza-mission-viejo-25104-marguerite-parkway" className="homepageButtonHref"> 
                Order Now 
              </a>
            </Col>*/}
            <Col xs="12" sm="12" md="12"  lg="12" xl="12" className="homepageCol homepageColLinks">
              <a target="_blank" alt="Order Now" className="homepageMainLinks" href="https://order.toasttab.com/online/oc-pizza-mission-viejo-25104-marguerite-parkway"> 
                Order Now 
              </a>
            </Col>
            <Col xs="12" sm="12" md="12" lg="12" xl="12" className="homepageCol homepageColLinks">
              <a href="/menu" alt="Menu" className="homepageMainLinks"> Menu </a>
            </Col>
            <Col xs="12" sm="12" md="12" lg="12" xl="12" className="homepageCol homepageColLinks">
              <a href="/drinks-happy-hour" alt="Drinks & Happy Hour" className="homepageMainLinks"> Drinks & Happy Hour </a>
            </Col>
            <Col xs="12" sm="12" md="12" lg="12" xl="12" className="homepageCol homepageColLinks">
              <a href="/specials" alt="Lunch & Daily Specials" className="homepageMainLinks"> 
                Lunch & Daily Specials 
              </a>
            </Col>
            <Col xs="12" sm="12" md="12" lg="12" xl="12" className="homepageCol homepageColLinks">
              <a href="/catering-menu" alt="Catering" className="homepageMainLinks"> 
                Catering
              </a>
            </Col>
            <Col xs="12" sm="12" md="12" lg="12" xl="12" className="homepageCol homepageColLinks">
              <a target="_blank" alt="Reviews" href="https://tally.so/r/w4xVRd" className="homepageMainLinks"> Leave Us a Review </a>
            </Col>
            <Col xs="12" sm="12" md="12" lg="12" xl="12" className="homepageCol homepageColLinks">
              <a target="_blank" alt="Join Rewards" href="https://www.toasttab.com/oc-pizza-mission-viejo-25104-marguerite-parkway/rewardsSignup" className="homepageMainLinks"> Join or Check Rewards</a>
            </Col>
          </Row>
        </Container>
      </div>
      <div className="showCase">
        <Container className="container-fluid">
          <Row>
            <Col xs="12" sm="12" md="4" lg="4" xl="4" className="homepageCol">
              <img className="showCaseCol" src={FlyerPizzaDeal}/>
            </Col>
            <Col xs="12" sm="12" md="4" lg="4" xl="4" className="homepageCol">
              <a href="https://tally.so/r/w4xVRd"  alt="10% Discount" className="contactHref">
                <img className="showCaseCol" src={Flyer10Discount}/>
              </a>
            </Col>
            <Col xs="12" sm="12" md="4" lg="4" xl="4" className="homepageCol">
              <img className="showCaseCol" src={FlyerWingsDeal}/>
            </Col>
            <Col xs="12" sm="12" md="4" lg="4" xl="4" className="homepageCol">
              <a href="/drinks-happy-hour" alt="Happy Hour" className="contactHref">
                <img className="showCaseCol" src={FlyerHappyHour}/>
              </a>
            </Col>
            <Col xs="12" sm="12" md="4" lg="4" xl="4" className="homepageCol">
              <a href="/specials" alt="Lunch Special" className="contactHref">
                <img className="showCaseCol" src={FlyerLunchSpecial}/>
              </a>
            </Col>
          </Row>
        </Container>
      </div>
      <div className="contactFooter">
        <Container>
          <Row>
            <Col xs="12" sm="12" md="4" lg="4" xl="4" className="contactCol">
              <a target="_blank" alt="Fundraise" href="https://docs.google.com/forms/d/e/1FAIpQLSesKpMMCV_wBCTMrFlToO1Q9-iNWn7HqKypIhNbdCLTgJfSxQ/viewform"  className="contactHref"> Fundraising </a>
            </Col>
            <Col xs="12" sm="12" alt="Sponsorship" md="4" lg="4" xl="4" className="contactCol">
              <a target="_blank" href="https://docs.google.com/forms/d/e/1FAIpQLSe7Xk06bwHXXJY60p2XXWJ-8h3WbO6w7MWL-3kYaSMN0uS_ZA/viewform"  className="contactHref"> Sponsorship </a>
            </Col>
          </Row>
        </Container>
      </div>
      <div className="contactFooter">
        <Container>
          <Row>
            <Col xs="12" sm="12" md="12" lg="12" xl="12" className="contactCol">
              <a target="_blank" href="tel:+19494298888"  alt="Phone" className="contactHref"> Phone: +1-949-429-8888 </a>
            </Col>
            <Col xs="12" sm="12" md="12" lg="12" xl="12" className="contactCol">
              <a target="_blank" href="mailto:ocpizzakitchen@gmail.com" alt="Email" className="contactHref"> Email: ocpizzakitchen@gmail.com </a>
            </Col>
            <Col xs="12" sm="12" md="12" lg="12" xl="12" className="contactCol">
              <a target="_blank" alt="Address" href="https://www.google.com/maps/place/OC+PIZZA+Mission+Viejo/@33.5979061,-117.6571249,15z/data=!4m2!3m1!1s0x0:0x1b632cdb408194be?sa=X&ved=2ahUKEwiu8-r8wJWEAxWtkO4BHWd6CIkQ_BJ6BAgNEAA" className="contactHref"> 25102 Marguerite Pkwy, Suite A, Mission Viejo, CA, 92692 </a>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}